import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  projectsBlock: {
    width: '100%',
  },
}));

export default useStyles;
